import React from "react";
import { Box } from "@mui/material";

const TextAreaComponent = ({height = "220px", onchange, error, placeholder, textlabel,isError, value, isRequired }) => {
return(<Box  style={{padding:10}}>
    <p style={{padding:0, margin:0, marginBottom:10, color:"#4E657C", fontSize:19, fontWeight:700}}>{textlabel}
        {isRequired && (
          <span style={{ color: "#f44336", marginLeft: 2 }}>*</span>
        )}
      </p>
    <textarea className="form-control" style={{height, resize: "none", width: "100%",}}  placeholder={placeholder} onChange={onchange} value={value} />
    {isError ? <p className="input-error-text">{error}</p> : null}
</Box>);
}

export default TextAreaComponent;